import React from 'react';
import ThreeBackground from '../components/ThreeBackground';
import style from '../styles/HomeNew.module.css';
import kong from './kong.png';

const Home: React.FC = () => {
  return (
    <main className={style.homeContainer}>
      <ThreeBackground />
      <img className={style.kong} src={kong} alt="Kong" />
    </main>
  );
};

export default Home;
